import { createContext, useContext, useState, useCallback, useEffect } from 'react';

const CartContext = createContext();

function loadCart() {
  try {
    const saved = sessionStorage.getItem('ttw_cart');
    return saved ? JSON.parse(saved) : [];
  } catch { return []; }
}

export function CartProvider({ children }) {
  const [items, setItems] = useState(loadCart);

  // Persist to sessionStorage on every change
  useEffect(() => {
    sessionStorage.setItem('ttw_cart', JSON.stringify(items));
  }, [items]);

  const addItem = useCallback((item) => {
    setItems((prev) => {
      const exists = prev.find((i) => i.service === item.service && i.option === item.option);
      if (exists) return prev;
      return [...prev, item];
    });
  }, []);

  const removeItem = useCallback((index) => {
    setItems((prev) => prev.filter((_, i) => i !== index));
  }, []);

  const clearCart = useCallback(() => setItems([]), []);

  const total = items.reduce((sum, item) => sum + item.price, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, clearCart, total, itemCount: items.length }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
